import { Action } from 'redux';
import { actionTypes as t } from '../actions';
import { WorkflowState } from '../ducks.types';

type EsFieldsState = WorkflowState['esFields'];
type CustomEventsState = WorkflowState['topLevelCustomEvents'];

interface FetchingAction {
  type: string;
  payload: EsFieldsState;
}

interface FetchingCustomEventsAction {
  type: string;
  payload: {
    topLevelCustomEvents: CustomEventsState;
  };
}

const initialEsFieldsState: EsFieldsState = {
  isFetchingCustomEventMappings: false,
  isFetchingUserMappings: false,
  mappings: {},
  isFetchingMappings: false,
};

export const topLevelCustomEventsReducer = (state: CustomEventsState = [], action: Action) => {
  switch (action.type) {
    case t.FETCH_TOP_LEVEL_CUSTOM_EVENTS_RESPONSE:
      return (action as FetchingCustomEventsAction).payload.topLevelCustomEvents;

    default:
      return state;
  }
};

export const esFieldsReducer = (state: EsFieldsState = initialEsFieldsState, action: Action) => {
  switch (action.type) {
    /* ----------  Custom event mappings ----------*/
    case t.FETCH_CUSTOM_EVENT_MAPPINGS_REQUEST:
      return { ...state, isFetchingCustomEventMappings: true };
    case t.FETCH_CUSTOM_EVENT_MAPPINGS_RESPONSE:
      return {
        ...state,
        customEventMappings: (action as FetchingAction).payload.customEventMappings,
        isFetchingCustomEventMappings: false,
      };
    case t.FETCH_CUSTOM_EVENT_MAPPINGS_ERROR:
      return { ...state, customEventMappings: [], isFetchingCustomEventMappings: false };
    /* ----------  User event mappings ----------*/
    case t.FETCH_USER_MAPPINGS_REQUEST:
      return { ...state, isFetchingUserMappings: true };
    case t.FETCH_USER_MAPPINGS_RESPONSE:
      return {
        ...state,
        isFetchingUserMappings: false,
        userMappings: (action as FetchingAction).payload.userMappings?.filter(
          (userEvent) => !userEvent.isHidden,
        ),
      };
    case t.FETCH_USER_MAPPINGS_ERROR:
      return { ...state, userMappings: [], isFetchingUserMappings: false };
    /* ----------  All event mappings ----------*/
    case t.FETCH_EVENT_FIELD_MAPPINGS_REQUEST:
      return { ...state, isFetchingMappings: true };
    case t.FETCH_EVENT_FIELD_MAPPINGS_RESPONSE:
      return {
        ...state,
        isFetchingMappings: false,
        mappings: (action as FetchingAction).payload.mappings,
      };
    case t.FETCH_EVENT_FIELD_MAPPINGS_ERROR:
      return { ...state, isFetchingMappings: false };
    default:
      return state;
  }
};

export const isFetchingEventFieldMappingsReducer = (
  state = false,
  action: Action,
  wfState: WorkflowState,
) => {
  switch (action.type) {
    case t.FETCH_CUSTOM_EVENT_MAPPINGS_ERROR:
    case t.FETCH_CUSTOM_EVENT_MAPPINGS_RESPONSE:
    case t.FETCH_EVENT_FIELD_MAPPINGS_ERROR:
    case t.FETCH_EVENT_FIELD_MAPPINGS_RESPONSE:
    case t.FETCH_USER_MAPPINGS_ERROR:
    case t.FETCH_USER_MAPPINGS_RESPONSE: {
      const { isFetchingCustomEventMappings, isFetchingMappings, isFetchingUserMappings } =
        wfState?.esFields || {};
      return !!(isFetchingCustomEventMappings && isFetchingMappings && isFetchingUserMappings);
    }
    case t.FETCH_CUSTOM_EVENT_MAPPINGS_REQUEST:
    case t.FETCH_EVENT_FIELD_MAPPINGS_REQUEST:
    case t.FETCH_USER_MAPPINGS_REQUEST:
      return true;
    default:
      return state;
  }
};
